import { z } from '@hono/zod-openapi'
import { vendorsTable } from '@mattrika/benefit-db'
import { createInsertSchema, createSelectSchema } from 'drizzle-orm/zod'
import { zCommonQuery } from '../common/common.model'

export type InsertVendor = z.infer<typeof zInsertVendor>
export type SelectVendor = z.infer<typeof zSelectVendor>
export type UpdateVendor = z.infer<typeof zUpdateVendor>
export type QueryVendors = z.infer<typeof zQueryVendors>
export type ColumnsOfVendorsTable = keyof typeof vendorsTable._.columns

export const zSelectVendor = createSelectSchema(vendorsTable)
export const zInsertVendor = createInsertSchema(vendorsTable).omit({
    id: true,
    createdAt: true,
    updatedAt: true,
})
export const zUpdateVendor = zInsertVendor.partial()
export const zQueryVendors = zInsertVendor
    .extend({
        id: z.string(),
        ids: z.string().array(),
        status: z.enum(['active', 'suspended']).optional(),
    })
    .extend(zCommonQuery.shape)
    .partial()
